import { render, staticRenderFns } from "./_receives.vue?vue&type=template&id=064edbe9&scoped=true&"
import script from "./_receives.vue?vue&type=script&lang=js&"
export * from "./_receives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064edbe9",
  null
  
)

export default component.exports